"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JovianLanterns = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const CardName_1 = require("../../CardName");
const ResourceType_1 = require("../../ResourceType");
const AddResourcesToCard_1 = require("../../deferredActions/AddResourcesToCard");
const CardRequirements_1 = require("../CardRequirements");
const Card_1 = require("../Card");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const CardRenderer_1 = require("../render/CardRenderer");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Units_1 = require("../../Units");
class JovianLanterns extends Card_1.Card {
    constructor() {
        super({
            cost: 20,
            tags: [Tags_1.Tags.JOVIAN],
            name: CardName_1.CardName.JOVIAN_LANTERNS,
            cardType: CardType_1.CardType.ACTIVE,
            resourceType: ResourceType_1.ResourceType.FLOATER,
            tr: { tr: 1 },
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.tag(Tags_1.Tags.JOVIAN)),
            metadata: {
                cardNumber: 'C18',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Spend 1 titanium to add 2 floaters here.', (eb) => {
                        eb.titanium(1).startAction.floaters(2);
                    }).br;
                    b.tr(1).floaters(2).asterix().br;
                    b.vpText('1 VP per 2 floaters here.');
                }),
                description: {
                    text: 'Requires 1 Jovian tag. Increase your TR 1 step. Add 2 floaters to ANY card.',
                    align: 'left',
                },
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.floaters(1, 2),
            },
        });
        this.resourceCount = 0;
    }
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (!super.canPlay(player))
            return false;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    canAct(player) {
        return player.titanium > 0;
    }
    action(player) {
        player.titanium--;
        player.addResourceTo(this, 2);
        return undefined;
    }
    play(player) {
        player.game.defer(new AddResourcesToCard_1.AddResourcesToCard(player, ResourceType_1.ResourceType.FLOATER, { count: 2 }));
        player.increaseTerraformRatingSteps(1);
        return undefined;
    }
    getVictoryPoints() {
        return Math.floor(this.resourceCount / 2);
    }
    getActionDetails(_player, card) {
        return new RedsPolicy_1.ActionDetails({ card: card, TRIncrease: 1 });
    }
}
exports.JovianLanterns = JovianLanterns;
//# sourceMappingURL=JovianLanterns.js.map